export default {
  Top: 1,
  Bottom: 2,
  Left: 3,
  Right: 4,
};
